import { searchParametersActions } from 'features/searchResultsFacets';
import Select from '@components/select';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectLivingAreas } from '../redux/selectors';

const select = document.querySelector('[data-living-areas-filter]');
const livingAreas$ = new Select(select).getObservable();
const setValue = (value) => {
  select.value = value || 0;
};

livingAreas$.subscribe((value) => {
  store.dispatch(searchParametersActions.fetchLivingAreas(value));
});

store$.pipe(map(selectLivingAreas), distinctUntilChanged()).subscribe(setValue);
